/**
 * Schéma ou photo avec repères numérotés : l'élève touche un numéro pour lire le nom et l'explication de la zone.
 * Sans réseau et sans pack, le texte de remplacement (alt) et la liste des repères restent lisibles.
 */
import { useState } from "react";
import type { ImageMarker } from "@jange/shared";
import { C } from "./theme.js";

export function MarkedImage({ src, alt, aspect, markers, lang, credit, onMarker }: { src: string | null; alt: string; aspect: number; markers: ImageMarker[]; lang: string; credit?: string | null; onMarker?: (id: string) => void }) {
  const [open, setOpen] = useState<string | null>(null);
  const [failed, setFailed] = useState(false);
  const label = (m: ImageMarker) => m.label[lang] ?? m.label.fr ?? m.id;
  const text = (m: ImageMarker) => m.text[lang] ?? m.text.fr ?? "";
  const current = markers.find((m) => m.id === open);
  return (
    <div style={{ border: `1px solid ${C.border}`, borderRadius: 18, padding: 10, display: "flex", flexDirection: "column", gap: 8, background: "#fff" }}>
      {src && !failed ? (
        <div style={{ position: "relative", width: "100%", aspectRatio: String(aspect), borderRadius: 12, overflow: "hidden", background: "#F6F7F9" }}>
          <img src={src} alt={alt} onError={() => setFailed(true)} style={{ position: "absolute", inset: 0, width: "100%", height: "100%", objectFit: "contain" }} />
          {markers.map((m, i) => (
            <button key={m.id} type="button" aria-label={`${i + 1}. ${label(m)}`} onClick={() => { setOpen(open === m.id ? null : m.id); onMarker?.(m.id); }}
              style={{ position: "absolute", left: `${m.x * 100}%`, top: `${m.y * 100}%`, transform: "translate(-50%, -50%)", width: 30, height: 30, borderRadius: 999, border: "2px solid #fff", background: m.id === open ? C.amber : C.teal, color: "#fff", fontWeight: 800, fontSize: 13, boxShadow: "0 1px 4px rgba(0,0,0,0.3)", cursor: "pointer", transition: "background-color 150ms ease" }}>
              {i + 1}
            </button>
          ))}
        </div>
      ) : (
        <div style={{ padding: 14, borderRadius: 12, background: C.amberTint, color: C.amberText, fontSize: 14, lineHeight: 1.45 }}>{alt || "Image indisponible sans connexion."}</div>
      )}
      {current ? (
        <div className="jg-in" role="status" style={{ borderRadius: 12, padding: "10px 12px", background: C.tealTint, color: C.ink, fontSize: 14, lineHeight: 1.45 }}>
          <b>{markers.indexOf(current) + 1}. {label(current)}</b>{text(current) ? <> — {text(current)}</> : null}
        </div>
      ) : markers.length > 0 ? (
        <div style={{ fontSize: 13, color: C.muted }}>Touche un numéro : {markers.map((m, i) => `${i + 1}. ${label(m)}`).join(" · ")}</div>
      ) : null}
      {credit && <div style={{ fontSize: 11, color: C.muted }}>{credit}</div>}
    </div>
  );
}
